import { AuthenticationAction, AuthenticationActionKeys } from './actions';
import Utils from '../../utils';

export interface AuthenticationFormState {
	login: string;
	password: string;
}

export enum Security {
	Excel = 'EXCEL',
	Saml = 'SAML'
}

export interface AuthenticationMode {
	method: Security;
	status: ConnectionStatus;
	samlUrl?: string;
	onCache?: boolean; // only used on Saml IOS, if the app was opened while offline
}

export enum ConnectionStatus {
	CONNECTED = 'connected',
	CONNECTING = 'connecting', // only used on Saml (IOS & Android)
	NEED_RECONNECT = 'need_reconnect', // only used on Saml IOS
	NOT_CONNECTED = 'not_connected'
}

export interface AuthenticationUserState {
	needCredentials: boolean;
	login: string;
	password: string;
	mode: AuthenticationMode | undefined;
}

export interface AuthenticationState {
	form: AuthenticationFormState;
	userInfos: AuthenticationUserState;
}

const initialUserInfosState: AuthenticationUserState = {
	needCredentials: false,
	login: '',
	password: '',
	mode: undefined
};

let initialState: AuthenticationState = {
	form: {
		login: '',
		password: '',
	},
	userInfos: initialUserInfosState
};

export function authentication(
	state: AuthenticationState = initialState,
	action: AuthenticationAction
): AuthenticationState {
	let newState = Utils.deepCopy(state);
	switch (action.type) {
		case AuthenticationActionKeys.SET_FORM_LOGIN:
			newState.form.login = action.value;
			return newState;
		case AuthenticationActionKeys.SET_FORM_PASSWORD:
			newState.form.password = action.value;
			return newState;
		case AuthenticationActionKeys.UPDATE_CREDENTIALS:
			newState.userInfos = Utils.deepCopy(action.userInfos);
			return newState;
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Authentication/reducer.ts